<template>
  <nav class="pager" :aria-label="'Pagination'|t" v-if="total > 1">
    <ul class="pagination text-center">
      <li v-if="current === 1" class="pagination-previous disabled">{{ 'First'|t }}</li>
      <li v-if="current > 1" class="pagination-previous"><a href="#" :aria-label="'First page'|t" @click.stop.prevent="go(1)">{{ 'First'|t }}</a></li>

      <li v-if="current === 1" class="pagination-previous disabled">{{ 'Previous'|t }}</li>
      <li v-if="current > 1" class="pagination-previous"><a href="#" :aria-label="'Previous page'|t" @click.stop.prevent="go(current - 1)">{{ 'Previous'|t }}</a></li>

      <li v-for="n in [-80, -50, -20]" v-if="computeJumpPage(n) !== 0"><a href="#" :aria-label="'Page %d'|t(computeJumpPage(n))" @click.stop.prevent="go(computeJumpPage(n))">{{ computeJumpPage(n) }}</a></li>
      <li v-if="computeJumpPage(-20) !== 0" class="ellipsis"></li>

      <li v-for="n in [-3, -2, -1]" v-if="computeNeighbourPage(n) !== 0"><a href="#" :aria-label="'Page %d'|t(computeNeighbourPage(n))" @click.stop.prevent="go(computeNeighbourPage(n))">{{ computeNeighbourPage(n) }}</a></li>

      <li class="current"><span class="show-for-sr">{{ 'You\'re on page %d'|t(current) }}</span>{{ current }}</li>

      <li v-for="n in [1, 2, 3]" v-if="computeNeighbourPage(n) !== 0"><a href="#" :aria-label="'Page %d'|t(computeNeighbourPage(n))" @click.stop.prevent="go(computeNeighbourPage(n))">{{ computeNeighbourPage(n) }}</a></li>

      <li v-if="computeJumpPage(20) !== 0" class="ellipsis"></li>
      <li v-for="n in [20, 50, 80]" v-if="computeJumpPage(n) !== 0"><a href="#" :aria-label="'Page %d'|t(computeJumpPage(n))" @click.stop.prevent="go(computeJumpPage(n))">{{ computeJumpPage(n) }}</a></li>

      <li v-if="current === total" class="pagination-next disabled">{{ 'Next'|t }}</li>
      <li v-if="current < total" class="pagination-next"><a href="#" :aria-label="'Next page'|t" @click.stop.prevent="go(current + 1)">{{ 'Next'|t }}</a></li>

      <li v-if="current === total" class="pagination-next disabled">{{ 'Last'|t }}</li>
      <li v-if="current < total" class="pagination-next"><a href="#" :aria-label="'Last page'|t" @click.stop.prevent="go(total)">{{ 'Last'|t }}</a></li>
    </ul>
  </nav>
</template>

<script>
  export default {
    name: 'Pager',
    props: {
      total: Number,
      current: Number
    },
    methods: {
      go(page) {
        this.$emit('pager-go', page)
      },
      computeNeighbourPage(n) {
        let value = this.current + parseInt(n);
        return value < 1 || value > this.total ? 0 : value;
      },
      computeJumpPage(n) {
        // https://stackoverflow.com/questions/11022488/javascript-using-round-to-the-nearest-10/11022517
        if (parseInt(n) === 0) {
          return 0;
        }

        if (parseInt(n) < 0) {
          let value = Math.ceil(((this.current + parseInt(n)) + 1) / 10) * 10;
          return value < 10 ? 0 : value;
        } else {
          let value = Math.ceil(((this.current + parseInt(n)) + 1) / 10) * 10;
          return value >= this.total ? 0 : value;
        }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Pager.vue